import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import wokeloLogo from "../assests/wokeloLogo.svg";
import {
  FaHome,
  FaPlus,
  FaSearch,
  FaChevronDown,
  FaSignOutAlt,
} from "react-icons/fa";
import Select, { components } from "react-select";
import { BsGlobeCentralSouthAsia } from "react-icons/bs";

import { useNavigate } from "react-router-dom";
import { logout } from "../store/slice/authSlice";
import { Accordion } from "flowbite-react";
import { options, typeEnmus } from "../helper";
import { Home } from "@mui/icons-material";

const Sidebar = () => {
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(
    window.location.href.split("/")[0]
  );
  useEffect(() => {
    setCurrentPage(window.location.href.split("/")[3]);
  }, [window.location.href]);

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaSearch className="text-slate-400 text-xs" />
      </components.DropdownIndicator>
    );
  };

  const getOptionsIntoDesiredFormat = (options) => {
    let allType = Object.values(typeEnmus);
    let formatedOptions = {};
    allType.map((item) => item.label).forEach((type) => {
      formatedOptions[type] = [];
    });
    options.forEach((option) => {
      formatedOptions[option.type]?.push(option);
    });
    return formatedOptions;
  };

  return (
    <div
      className="h-screen w-72 flex-shrink-0 bg-white"
      style={{ borderRight: "1px solid #e5e7eb" }}
    >
      <div className="flex h-full flex-col overflow-hidden">
        {/* Logo */}
        <div className="px-5 pt-6 pb-4" style={{ borderBottom: "1px solid #f0f0f0" }}>
          <img className="w-[140px]" src={wokeloLogo} />
        </div>

        {/* Scrollable nav area */}
        <div className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
          {/* Search */}
          <div className="mb-4">
            <Select
              placeholder="Search tools..."
              components={{ DropdownIndicator }}
              unstyled
              classNames={{
                control: () =>
                  "flex items-center px-3 h-10 text-sm rounded-lg border border-gray-200 bg-gray-50 text-gray-700 hover:border-gray-300 transition-colors",
                menuList: () =>
                  "mt-1 rounded-lg border border-gray-200 bg-white shadow-lg text-sm overflow-hidden",
                placeholder: () => "text-gray-400 text-sm",
                option: () =>
                  "px-3 py-2 text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors",
                input: () => "text-gray-700",
                singleValue: () => "text-gray-700",
              }}
              formatOptionLabel={(data) => (
                <div className="flex gap-2 items-center cursor-pointer text-gray-700">
                  <span className="text-gray-400 text-xs">{data.icon}</span>
                  {data.label}
                </div>
              )}
              openMenuOnClick={false}
              onChange={(e) => {
                navigate("/" + e.value);
              }}
              options={options}
              isSearchable={true}
            />
          </div>

          {/* Home */}
          <button
            onClick={() => navigate("/")}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 group ${
              currentPage === ""
                ? "bg-indigo-50 text-indigo-600 border border-indigo-100"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            <Home
              className={`text-base transition-colors ${
                currentPage === "" ? "text-indigo-500" : "text-gray-400 group-hover:text-gray-600"
              }`}
            />
            Home
          </button>

          {/* Accordion groups */}
          <div className="mt-2 space-y-1">
            {Object.entries(getOptionsIntoDesiredFormat(options)).map(
              ([type, items]) => {
                const typeInfo = Object.values(typeEnmus).find(
                  (item) => item.label === type
                );
                const hasActive = items.some((c) => currentPage === c.value);
                return (
                  <AccordionGroup
                    key={type}
                    type={type}
                    typeInfo={typeInfo}
                    items={items}
                    currentPage={currentPage}
                    hasActive={hasActive}
                    navigate={navigate}
                  />
                );
              }
            )}
          </div>
        </div>

        {/* Footer */}
        <div
          className="px-4 py-4 space-y-1"
          style={{ borderTop: "1px solid #f0f0f0" }}
        >
          <div className="px-3 py-1">
            <div className="text-xs text-gray-400 font-medium uppercase tracking-wider">
              {authData.env}
            </div>
            <div className="text-sm text-gray-700 mt-0.5 font-medium">
              {authData.username}
            </div>
          </div>
          <button
            onClick={() => dispatch(logout())}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-gray-500 hover:text-red-500 hover:bg-red-50 transition-all duration-150 group"
          >
            <FaSignOutAlt className="text-gray-400 group-hover:text-red-400 transition-colors" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

const AccordionGroup = ({ type, typeInfo, items, currentPage, hasActive, navigate }) => {
  const [open, setOpen] = useState(hasActive);

  return (
    <div className="rounded-lg overflow-hidden">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`w-full flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-all duration-150 rounded-lg ${
          hasActive
            ? "text-gray-900 bg-gray-50"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
        }`}
      >
        <span
          className={`text-base transition-colors ${
            hasActive ? "text-indigo-500" : "text-gray-400"
          }`}
        >
          {typeInfo?.logo}
        </span>
        <span className="flex-1 text-left text-xs font-semibold uppercase tracking-wider">
          {type}
        </span>
        <FaChevronDown
          className={`text-gray-400 text-xs transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div className="ml-3 pl-3 mt-0.5 space-y-0.5" style={{ borderLeft: "1px solid #e5e7eb" }}>
          {items.map((card) => (
            <button
              key={card.value}
              onClick={() => navigate(`/${card.value}`)}
              className={`w-full flex items-center text-left gap-2.5 px-3 py-2 rounded-md text-xs transition-all duration-150 ${
                currentPage === card.value
                  ? "bg-indigo-50 text-indigo-600 font-medium"
                  : "text-gray-500 hover:text-gray-900 hover:bg-gray-50"
              }`}
            >
              <span
                className={`flex-shrink-0 w-4 h-4 flex items-center justify-center text-sm [&>svg]:w-4 [&>svg]:h-4 [&>*]:text-base ${
                  currentPage === card.value ? "text-indigo-500" : "text-gray-400"
                }`}
              >
                {card.icon}
              </span>
              <span className="text-left">{card.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
